/* eslint-disable prettier/prettier */
import { useLocation } from "@reach/router";
import { Link } from "gatsby";
import { AnchorLink } from "gatsby-plugin-anchor-links";
import { decode } from "html-entities";
import React, { FunctionComponent, useEffect, useState } from "react";
import { getLocalizedUrl } from "../../utils/localeURL";
import { PuxMediaSelectorType } from "../contentParts/mediaImage/PuxMediaSelector";
import PuxPicture from "../contentParts/mediaImage/PuxPicture";
import LottieAnimation from "../../utils/LottieAnimation";

export interface MenuItem {
  [x: string]: any;
  contentType: string;
  render: string;
  contentMenuItemDuplicateAlias?: string;
  contentMenuItemDuplicateMainItem?: boolean;
  contentMenuItemDuplicateHide?: boolean;
  linkMenuItem?: {
    name: string;
    url: string;
  };
}
export interface MenuCategory {
  categoryItemDescription: string;
  categoryItemName: string;
  menuItemsList: {
    menuItems: [MenuItem];
  };
}
export interface TopMenuItem {
  render: string;
  contentType: string;
  linkMenuItem?: {
    name: string;
    url: string;
  }
  menuItemsList: {
    menuItems: [MenuCategory];
  } | null;
  contentMenuItemCTA: {
    html: string;
  };
  contentMenuItemImage: PuxMediaSelectorType;
  contentMenuItemIsButton: boolean;
  contentMenuItemDuplicateAlias: string | null;
  contentMenuItemLinkText: string
}
export interface HeaderData {
  menuItems: TopMenuItem[];
  menuLinkedinLink: string;
  menuXLink: string;
  menuXingLink: string;
}
interface HeaderNavProps {
  headerData: HeaderData;
}
export interface renderData {
  url: string;
  name: string;
  internal?: boolean;
}

export interface MenuDuplicate {
  main: MenuItem[];
  nav: MenuItem[];
}

const renderCategory = (data: MenuCategory, index: number, active: number, setActiveCategory: Function) => {
  return data.menuItemsList ? (
    data.menuItemsList?.menuItems.map((menuItem, menuIndex) => {
      let renderDuplicateAlias = false;
      switch (menuItem.contentType) {
        case `ContentMenuItem`:
          const itemNavData: renderData = JSON.parse(menuItem.render);
          return (
            <Link
              className={`HeaderNavSubmenu-category${active === menuIndex ? ` is-active` : ``}`}
              //activeClassName="is-active"
              //partiallyActive={true}
              onMouseEnter={() => setActiveCategory(menuIndex)}
              to={`${getLocalizedUrl(itemNavData.url)}`}
              key={menuIndex}
              onClick={(e) => {
                let href = e.target.href.replace(window.location.origin, "")
                if (href === window.location.pathname) {
                  window.location.href = href
                }
              }}
            >
              {renderDuplicateAlias
                ? menuItem.contentMenuItemDuplicateAlias
                  ? menuItem.contentMenuItemDuplicateAlias
                  : decode(itemNavData.name)
                : decode(itemNavData.name)}
            </Link>
          );
        case `LinkMenuItem`:
          return (
            <a
              className={`HeaderNavSubmenu-categoryLink${active === menuIndex ? ` is-active` : ``}`}
              key={menuIndex} href={menuItem.linkMenuItem?.url}
              target="_blank" rel="noopener"
              onMouseEnter={() => setActiveCategory(menuIndex)}
              onClick={(e) => {
                let href = e.target.href.replace(window.location.origin, "")
                if (href === window.location.pathname) {
                  window.location.href = href
                }
              }}
            >
              {menuItem.linkMenuItem?.name}
            </a>
          );
        default:
          return null;
      }
    })
  ) : null;
};

const renderCategoryContent = (data: MenuCategory, activeCategory) => {
  return data?.menuItemsList?.menuItems.map((item, indexItem) => {
    if (item.contentType === "LinkMenuItem") {
      return
    }
    const itemNavData: renderData = JSON.parse(item?.render);
    return item.contentMenuItemCTA.html ?
      <div
        className={`HeaderNavSubmenu-contentBody${indexItem === activeCategory ? ` is-active` : ``}`}
        key={indexItem}
      >
        <div dangerouslySetInnerHTML={{
          __html: item.contentMenuItemCTA.html,
        }}></div>
        {itemNavData.url ?
          <Link
            className={`Button Button--primary`}
            to={getLocalizedUrl(itemNavData.url)}
            onClick={(e) => {
              let href = e.target.href.replace(typeof window !== "undefined" ? window.location.origin : "", "")
              if (href === window.location.pathname) {
                window.location.href = href
              }
            }}
          >
            {item.contentMenuItemLinkText ? item.contentMenuItemLinkText : "Link"}
          </Link> : null
        }
      </div>
      : null
  })
}

const renderCategoryImages = (data: MenuCategory, activeCategory) => {
  return data?.menuItemsList?.menuItems.map((item, indexItem) => {
    if (item.contentType === "LinkMenuItem") {
      return
    }
    return item.contentMenuItemImage ?
      <div
        className={`HeaderNavSubmenu-image${indexItem === activeCategory ? ` is-active` : ``}`}
        key={indexItem}
      >
        <PuxPicture
          {...item.contentMenuItemImage}
          width="100%"
          height="auto"
          lightbox={false}
          disableLazyload={false}
        />
      </div>
      : null
  })
}

const renderSubmenu = (data: TopMenuItem, hoverFnc: any, setActiveMenuItem: any, isOpened: boolean) => {
  const [activeCategory, setActiveCategory] = useState(0)

  return (
    <div
      className={`HeaderNavSubmenu`}
    >
      <div>
        <button className="HeaderNavSubmenu-close" onClick={() => { hoverFnc(false), setActiveMenuItem(null) }}></button>
        <div className={`HeaderNavSubmenu-categories`}>
          {data.menuItemsList?.menuItems.map((category, index) =>
            renderCategory(category, index, activeCategory, setActiveCategory)
          )}
        </div>
        <div className={`HeaderNavSubmenu-content`}>
          {data.menuItemsList?.menuItems.map((category, index) =>
            <div key={index}>
              {renderCategoryContent(category, activeCategory)}
            </div>
          )}
        </div>
        <div className="HeaderNavSubmenu-images">
          {data.menuItemsList?.menuItems.map((category, index) =>
            <div key={index}>
              {renderCategoryImages(category, activeCategory)}
            </div>
          )}
        </div>
        {isOpened && <LottieAnimation />}
      </div>
    </div>
  );
};

const renderTopMenuItem = (data: TopMenuItem, index: number, activeTopMenuItem: number | null, setActiveTopMenuItem: any) => {
  const [opened, setOpened] = React.useState(false);
  const [expanded, setExpanded] = React.useState(false);
  let itemNavData: renderData | undefined = undefined

  if (!data.render) {
    if (data.contentType === "LinkMenuItem") {
      if (!data.linkMenuItem?.name) return
      if (!data.linkMenuItem?.url) return

      itemNavData = { ...data.linkMenuItem, internal: false }
    } else {
      return
    }
  } else {
    itemNavData = JSON.parse(data.render);
  }
  
  useEffect(() => {
    if (activeTopMenuItem !== index) {
      setOpened(false)
      setExpanded(false)
    } else if (activeTopMenuItem === index) {
      if (window.innerWidth < 1200) {
        setExpanded(true);
      } else {
        setOpened(true);
      }
    }
  }, [activeTopMenuItem])

  if (!itemNavData) return

  const location = useLocation();

  // function hasActiveDuplicateMenu(): boolean {
  //   if (location.pathname === getLocalizedUrl(itemNavData?.url)) {
  //     return true;
  //   }

  //   let isActive = false;
  //   if (data.menuItemsList != null) {
  //     data.menuItemsList?.menuItems.map((category) => {
  //       category.menuItemsList?.menuItems.map((menuItem) => {
  //         if (menuItem.contentType === `ContentMenuItem`) {
  //           const menuItemData: renderData = JSON.parse(menuItem.render);
  //           if (getLocalizedUrl(menuItemData?.url) === location.pathname) {
  //             isActive = true;
  //           }
  //         }
  //       });
  //     });
  //   }

  //   return isActive;
  // }

  // hasActiveDuplicateMenu();

  const pathname = location.pathname;
  const isInternal = itemNavData.internal ?? true;

  return (
    <li
      className={`${data.menuItemsList != null && data.menuItemsList?.menuItems?.length
        ? `has-submenu`
        : ``
        }${opened && (activeTopMenuItem === index) ? ` is-opened` : ``
        } ${expanded ? ` is-expanded` : ``}`}
      key={index}
    >
      {itemNavData.url.startsWith(`#`) && (
        <AnchorLink
          to={pathname + itemNavData.url}
          className={data.contentMenuItemIsButton ? "Button Button--primary" : undefined}
        >
          {decode(itemNavData.name)}
          {data.menuItemsList != null &&
            data.menuItemsList?.menuItems?.length && (
              <span className="HeaderNavSubmenu-arrow"></span>
            )}
        </AnchorLink>
      )}
      {!itemNavData.url.startsWith(`#`) && isInternal && (
        <Link
          activeClassName="is-active"
          className={data.contentMenuItemIsButton ? "Button Button--primary" : undefined}
          partiallyActive={true}
          to={`${getLocalizedUrl(itemNavData.url)}`}
          onClick={(e) => {
            if (e.target.classList.contains("HeaderNavSubmenu-arrow") || e.target.parentNode.querySelector(".HeaderNavSubmenu-arrow")) {
              e.preventDefault()
              if (data.menuItemsList != null) {
                setActiveTopMenuItem((active) => active === index ? null : index);
              }
            }
          }}
        >
          {decode(itemNavData.name)}
          {data.menuItemsList != null &&
            data.menuItemsList?.menuItems?.length && (
              <span className="HeaderNavSubmenu-arrow"></span>
            )}
        </Link>
      )}
      {!itemNavData.url.startsWith(`#`) && !isInternal && (
        <a
          href={itemNavData.url}
          target={typeof window !== "undefined" && itemNavData.url.startsWith("https://") ? "_blank" : "_self"}
          rel={typeof window !== "undefined" && itemNavData.url.startsWith("https://") ? "external nofollow" : "follow"}
          onClick={(e) => {
            let href = e.target.href.replace(typeof window !== "undefined" ? window.location.origin : "", "")
            if (href === window.location.pathname) {
              window.location.href = href
            }
          }}
          className={data.contentMenuItemIsButton ? "Button Button--primary" : undefined}
        >
          {decode(itemNavData.name)}
          {data.menuItemsList != null &&
            data.menuItemsList?.menuItems?.length && (
              <span className="HeaderNavSubmenu-arrow"></span>
            )}
        </a>
      )}
      {data.menuItemsList != null && data.menuItemsList?.menuItems?.length ? (
        <>
          <div
            className="HeaderNavSubmenu-expander"
            onClick={(e) => {
              e.preventDefault();
              setExpanded(!expanded);
              setActiveTopMenuItem((active) => active === index ? null : index);
            }}
          ></div>
          {renderSubmenu(data, setOpened, setActiveTopMenuItem, opened)}
        </>
      ) : null}
    </li>
  );
};

const HeaderNav: FunctionComponent<HeaderNavProps> = (props) => {
  const [activeTopMenuItem, setActiveTopMenuItem] = React.useState<null | number>(null);

  return (
    <nav className={`HeaderNav`}>
      <ul>
        {props?.headerData?.menuItems?.map((item, index) =>
          renderTopMenuItem(item, index, activeTopMenuItem, setActiveTopMenuItem)
        )}
      </ul>
      {(props.headerData?.menuLinkedinLink || props.headerData?.menuXingLink || props.headerData?.menuXLink) ?
        <div className={`HeaderNavShareSection`}>
          <div>Share your experience at:</div>
          <div className={`HeaderNavShareSection-Icons`}>
            {props.headerData?.menuLinkedinLink ? <a href={props.headerData.menuLinkedinLink} className={`HeaderNavShareSection-LinkedInIcon`}></a> : null}
            {props.headerData?.menuXingLink ? <a href={props.headerData.menuXingLink} className={`HeaderNavShareSection-XingIcon`}></a> : null}
            {props.headerData?.menuXLink ? <a href={props.headerData.menuXLink} className={`HeaderNavShareSection-XIcon`}></a> : null}
          </div>
        </div>
        : null}
    </nav>
  );
};

export default HeaderNav;
